export default "/images/save-icon.svg?45c050c2178576c791815817c6847c9b";